
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,
            modal_adjust: false,
            modal_tranfer: false,


            loading: false,
            data: null,
            data_warehouse: [],
            data_category: [],
            serial_numbers: [],

            warehouse_id: "",
            category_id: "",
            warehouse_from_id: "",
            warehouse_to_id: "",
            product_id: "",
            action_type: 0,
            quantity: "",
            detail: "",

            quantity_fix: 0,

            page: 1,
            data_search: "",
            warehouse_id: "",
            all_stock_id: ""
        }
    }
    async componentDidMount() {
        await this.Get();
        await this.GetCategory();
        await this.GetWarehouse();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            category_id: this.state.category_id,
            warehouse_id: ""
        }
        let result = await GET(tokens, "v1/TH/stock-manage/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }
    GetCategory = async () => {
        this.setState({ loading: true });
        let result = await GET(tokens, "v1/TH/product-manage/product-category/list/" + getStorage("branch").branch_id,);
        if (result && result.status) {
            console.log("Cat "+result);
            this.setState({ data_category: result.data });
        }
        this.setState({ loading: false });
    }
    GetWarehouse = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: ""
        }
        let result = await GET(tokens, "v1/TH/warehouse-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({
                data_warehouse: result.data.map(e => {
                    return { value: e.warehouse_id, label: e.warehouse_name }
                })
            });
        }
        this.setState({ loading: false });
    }
    Create = async () => {
        this.setState({ loading: true });
        let body = {
            serial_numbers: this.state.serial_numbers,
            warehouse_from_id: this.state.warehouse_from_id ? this.state.warehouse_from_id.value : "",
            warehouse_to_id: this.state.warehouse_to_id ? this.state.warehouse_to_id.value : "",
            product_id: this.state.product_id,
            action_type: this.state.action_type,
            quantity: Number(this.state.quantity),
            detail: this.state.detail,
        }
        let result = await POST(tokens, "v1/TH/stock-manage/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/stock/list-stock");
        }
        this.setState({ loading: false });
    }
    Delete = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/stock-manage/delete/" + this.state.all_stock_id, null);
        if (result && result.status) {
            success_url("/stock/list-stock");
        }
        this.setState({ loading: false });
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการสต๊อก" page3="สต๊อกสินค้า" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>สต๊อกสินค้า</b></h3>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />
                                <select className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    onChange={(e) => {
                                        this.setState({ category_id: e.target.value, page: 1 })
                                        setTimeout(() => {
                                            this.Get();
                                        }, 10);
                                    }}
                                    value={this.state.category_id}>
                                    <option value="">หมวดหมู่</option>
                                    { this.state.data_category.map((item, index) => (
                                        <option value={item.category_id}>{item.category_name}</option>
                                    ))}
                                </select>
                                <button className="btn btn-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1 mb-2" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped" style={{ marginBottom: 200 }}>
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">รหัสสินค้า</th>
                                            <th className="text-left text-white">ชื่อสินค้า</th>
                                            <th className="text-end text-white">ราคา</th>
                                            <th className="text-center text-white">จำนวน</th>
                                            <th className="text-left text-white">หมวดหมู่</th>
                                            <th className="text-left text-white">ประเภท</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.product_main_data.product_code ? item.product_main_data.product_code : "-"}</td>
                                                <td className="text-start">{item.product_main_data.product_name ? item.product_main_data.product_name : "-"}</td>
                                                <td className="text-end">{item.product_main_data.sell_price ? toFixed(item.product_main_data.sell_price) : "0.00"}</td>
                                                <td className="text-center">{item.quantity ? item.quantity : "0"}</td>
                                                <td className="text-start">{item.product_main_data.category_name ? item.product_main_data.category_name : "-"}</td>
                                                <td className="text-start">{item.product_main_data.product_type ? item.product_main_data.product_type : "-"}</td>
                                                <td className="text-center">
                                                    {item.product_main_data.product_type === "อะไหล่"&&(
                                                    <div className="dropdowns">
                                                        <span className="dropbtns pointer">
                                                            <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center">
                                                                <label className="pointer icon text-primary p-2">{"\uf141"}</label>
                                                            </div>
                                                        </span>
                                                        <div className="dropdowns-content wpx-250 bg-white text-start">
                                                            <a className="pointer" onClick={() => {
                                                                this.setState({
                                                                    modal_adjust: true,
                                                                    action_type: 1,
                                                                    product_id: item.product_main_data.product_id,
                                                                    product_code: item.product_main_data,
                                                                    warehouse_from_id: "",
                                                                    warehouse_to_id: "",
                                                                    quantity: "",
                                                                    detail: "",
                                                                })
                                                            }}>
                                                                <label className="icon mx-2">{"\uf1de"}</label>ปรับสต๊อก
                                                            </a>
                                                            <a className="pointer" onClick={() => {
                                                                this.setState({
                                                                    modal_tranfer: true,
                                                                    action_type: 4,
                                                                    product_id: item.product_main_data.product_id,
                                                                    product_code: item.product_main_data,
                                                                    warehouse_from_id: "",
                                                                    warehouse_to_id: "",
                                                                    quantity: "",
                                                                    detail: "",
                                                                })
                                                            }}>
                                                                <label className="icon mx-2">{"\uf0ec"}</label>โอนย้าย
                                                            </a>
                                                            {/* <a className="pointer" onClick={() => { this.setState({ modal_delete: true, all_stock_id: item.all_stock_id }) }}>
                                                                <label className="icon mx-2">{"\uf1f8"}</label>ลบข้อมูล
                                                            </a> */}
                                                        </div>
                                                    </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* ปรับสต๊อก */}
                <Modal show={this.state.modal_adjust}
                    onHide={() => { this.setState({ modal_adjust: false }) }}>
                    <Modal.Header><Modal.Title><b>สินค้า A</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* คลังสินค้า */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">คลังสินค้า:</label>
                            <Select
                                className="form-control select-search"
                                styles={select_style}
                                options={this.state.data_warehouse}
                                onChange={(e) => {
                                    this.setState({ warehouse_to_id: e });
                                }}
                                value={this.state.warehouse_to_id}
                                isClearable
                            ></Select>
                        </div>
                        <div className="row mb-2">
                            <div className="col-4">
                                <div className={"card pointer border-0 rounded-lg px-2 py-4 d-flex align-items-center justify-content-center" + (this.state.action_type === 1 ? " bg-primary text-white" : " bg-primary-light")}
                                    onClick={() => { this.setState({ action_type: 1 }) }}
                                >
                                    <label className="icon text-32 pointer">{"\uf466"}</label>
                                    <label className="pointer">เพิ่มจำนวนสินค้า</label>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className={"card pointer border-0 rounded-lg px-2 py-4 d-flex align-items-center justify-content-center" + (this.state.action_type === 2 ? " bg-primary text-white" : " bg-primary-light")}
                                    onClick={() => { this.setState({ action_type: 2 }) }}
                                >
                                    <label className="icon text-32 pointer">{"\uf466"}</label>
                                    <label className="pointer">ลดจำนวนสินค้า</label>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className={"card pointer border-0 rounded-lg px-2 py-4 d-flex align-items-center justify-content-center" + (this.state.action_type === 3 ? " bg-primary text-white" : " bg-primary-light")}
                                    onClick={() => { this.setState({ action_type: 3 }) }}
                                >
                                    <label className="icon text-32 pointer">{"\uf466"}</label>
                                    <label className="pointer">นับจำนวนสินค้าใหม่</label>
                                </div>
                            </div>
                        </div>
                        {/* จำนวน */}

                        <label className="mb-2">จำนวน:</label>
                        <div className="w-100 mb-2">
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => {
                                    if (!float(e.target.value)) {
                                        return
                                    }
                                    this.setState({ quantity: e.target.value })
                                }}
                                value={this.state.quantity}
                            />
                        </div>
                        { this.state.quantity > 0 && this.state.product_code['have_serial'] && (
                            <label className="mb-2">Serial Number</label>
                        )}
                        {this.state.quantity > 0 && this.state.product_code['have_serial'] && Array.from({ length: this.state.quantity }, (_, index) => (
                            <div className="w-100 mb-2" key={index}>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder={`Serial Number ${index + 1}`}
                                    onChange={(e) => {
                                        const serialNumbers = this.state.serial_numbers || [];
                                        serialNumbers[index] = e.target.value;
                                        this.setState({ serialNumbers });
                                    }}
                                    value={this.state.serialNumbers ? this.state.serialNumbers[index] : ""}
                                />
                            </div>
                        ))}
                        <div className="w-100 mb-2">
                            <label className="mb-2">หมายเหตุ :</label>
                            <textarea
                                className="form-control mb-2"
                                type="text"
                                placeholder=""
                                onChange={(e) => { this.setState({ detail: e.target.value }) }}
                                value={this.state.detail}
                                rows={5}
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_adjust: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100" onClick={() => {
                                    if (!this.state.warehouse_to_id) {
                                        alert("warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
                                        return;
                                    } else if (!this.state.quantity) {
                                        alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                        return;
                                    }
                                    if ( 
                                        this.state.product_code['have_serial'] && (
                                            this.state.serial_numbers.length < Number(this.state.quantity) || 
                                            this.state.serial_numbers.length === 0
                                        )
                                    ) {
                                        alert("warning", "แจ้งเตือน", "กรุณากรอก Serial Number 1");
                                        return;
                                    } else {
                                        for (const sn of this.state.serial_numbers) {
                                            if ( !sn ){
                                                alert("warning", "แจ้งเตือน", "กรุณากรอก Serial Number 2");
                                                return;
                                            }
                                        }
                                    }
                                    this.Create()
                                }}>
                                    บันทึก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* โอนย้าย */}
                <Modal show={this.state.modal_tranfer}
                    onHide={() => { this.setState({ modal_tranfer: false }) }}>
                    <Modal.Header><Modal.Title><b>สินค้า A</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* คลังสินค้า */}
                        <div className="row">
                            <div className="col-5">
                                <div className="w-100 mb-2">
                                    <label className="mb-2">คลังสินค้า:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_warehouse}
                                        onChange={(e) => {
                                            this.setState({ warehouse_from_id: e });
                                        }}
                                        value={this.state.warehouse_from_id}
                                        isClearable
                                    ></Select>
                                </div>
                            </div>
                            <div className="col-2">
                                <div className="mt-4 wpx-50 hpx-50 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                    <div className="text-center">
                                        <label className="mb-0">ไปยัง</label>
                                        <span className="icon text-20">{"\uf0ec"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-5">
                                <div className="w-100 mb-2">
                                    <label className="mb-2">คลังสินค้า:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_warehouse}
                                        onChange={(e) => {
                                            this.setState({ warehouse_to_id: e });
                                        }}
                                        value={this.state.warehouse_to_id}
                                        isClearable
                                    ></Select>
                                </div>
                            </div>
                        </div>

                        {/* จำนวน */}
                        <label className="mb-2">จำนวน:</label>
                        <div className="w-100 mb-2">
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => {
                                    if (!float(e.target.value)) {
                                        return
                                    }
                                    this.setState({ quantity: e.target.value })
                                }}
                                value={this.state.quantity}
                            />
                        </div>
                        { this.state.quantity > 0 && this.state.product_code['have_serial'] && (
                            <label className="mb-2">Serial Number</label>
                        )}
                        {this.state.quantity > 0 && this.state.product_code['have_serial'] && Array.from({ length: this.state.quantity }, (_, index) => (
                            <div className="w-100 mb-2" key={index}>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder={`Serial Number: ${index + 1}`}
                                    onChange={(e) => {
                                        const serialNumbers = this.state.serial_numbers || [];
                                        serialNumbers[index] = e.target.value;
                                        this.setState({ serialNumbers });
                                    }}
                                    value={this.state.serial_numbers ? this.state.serial_numbers[index] : ""}
                                />
                            </div>
                        ))}
                        <div className="w-100 mb-2">
                            <label className="mb-2">หมายเหตุ :</label>
                            <textarea
                                className="form-control mb-2"
                                type="text"
                                placeholder=""
                                onChange={(e) => { this.setState({ detail: e.target.value }) }}
                                value={this.state.detail}
                                rows={5}
                            />
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_tranfer: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100" onClick={() => {
                                    if (!this.state.warehouse_from_id) {
                                        alert("warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
                                        return;
                                    } else if (!this.state.warehouse_to_id) {
                                        alert("warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
                                        return;
                                    } else if (!this.state.quantity) {
                                        alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                        return;
                                    }
                                    if ( 
                                        this.state.serial_numbers.length < Number(this.state.quantity) || 
                                        this.state.serial_numbers.length === 0
                                    ) {
                                        alert("warning", "แจ้งเตือน", "กรุณากรอก Serial Number 1");
                                        return;
                                    } else {
                                        for (const sn of this.state.serial_numbers) {
                                            if ( !sn ){
                                                alert("warning", "แจ้งเตือน", "กรุณากรอก Serial Number 2");
                                                return;
                                            }
                                        }
                                    }
                                    this.Create()
                                }}>
                                    บันทึก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบสินค้า</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบสินค้านี้หรือไม่
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
